'use client';
import { useEffect, useState } from 'react';

interface Stats {
  total: number;
  avg: number | null;
  distribution: { score: number; count: number }[];
}

export function GridDistribution({ date, yourScore }: { date: string; yourScore: number }) {
  const [stats, setStats] = useState<Stats | null>(null);
  useEffect(() => {
    let live = true;
    fetch(`/api/spot/grid/${date}/stats`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (live) setStats(d as Stats);
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, [date]);

  if (!stats || stats.total === 0) return null;
  const max = Math.max(...stats.distribution.map((b) => b.count), 1);
  const byScore = new Map(stats.distribution.map((b) => [b.score, b.count]));

  return (
    <div style={{ maxWidth: 360, margin: '16px auto 0', textAlign: 'left' }}>
      <p style={{ fontSize: 13, color: 'var(--gp-ink-3, #6b6358)', textAlign: 'center' }}>
        {stats.total} played · avg {stats.avg ?? '—'}/9
      </p>
      {Array.from({ length: 10 }, (_, n) => {
        const count = byScore.get(n) ?? 0;
        const pct = Math.round((count / max) * 100);
        const mine = n === yourScore;
        return (
          <div key={n} style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '2px 0' }}>
            <span
              style={{ width: 18, fontSize: 12, textAlign: 'right', color: 'var(--gp-ink, #1a1612)' }}
            >
              {n}
            </span>
            <div
              style={{ flex: 1, background: 'var(--gp-rule, rgba(26,22,18,0.14))', borderRadius: 4 }}
            >
              <div
                style={{
                  width: `${pct}%`,
                  minWidth: count ? 16 : 0,
                  height: 16,
                  borderRadius: 4,
                  background: mine ? 'var(--coral-deep, #b56147)' : 'var(--coral-soft, #f9d5c3)',
                }}
              />
            </div>
            <span style={{ width: 24, fontSize: 12, color: 'var(--gp-ink-3, #6b6358)' }}>
              {count}
            </span>
          </div>
        );
      })}
    </div>
  );
}
